"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data_model_1 = require("../data-model");
var unique_id_1 = require("../lib/unique-id");
/**
 * 所有图形的基类
 * @since 2.0
 */
var Shape = /** @class */ (function () {
    /**
     * @constructor
     * @param ctx 上下文
     * @since 2.0
     */
    function Shape(ctx, coord, helpers) {
        /**
         * 过滤的数据系列名
         * @since 2.0
         */
        this.disabledKeys = [];
        /**
         * 图形设置
         */
        this.options = {
            dataLabels: {
                enable: false,
            },
        };
        var cls = ctx.classPrefix + "-chart-series-group";
        this.id = unique_id_1.uniqueId("shape_");
        this.ctx = ctx;
        this.model = new data_model_1.DataModel();
        this.coordinate = coord;
        this.helpers = helpers;
        // 如果图形绘制区默认先使用已存在的绘制区，如果没有则创建一个
        this.seriesGroup = this.ctx.root.select("." + cls);
        if (!this.seriesGroup.node()) {
            this.seriesGroup = this.ctx.root
                .append("g")
                .attr("class", cls)
                .attr("data-z-index", "3");
        }
    }
    Shape.prototype.shape = function (cfg) {
        this.options = cfg;
        return this;
    };
    return Shape;
}());
exports.Shape = Shape;
//# sourceMappingURL=shape.js.map